module.exports = __webpack_public_path__ + "img/badge-communication-silver-brightbg.a23578f9.svg";